var camel2hyphen=function(e){return e.replace(/[A-Z]/g,function(e){return"-"+e.toLowerCase()}).toLowerCase()};module.exports=camel2hyphen;